<template>
  <div class="home">
    <modal transition-name="fade-side" appear :comp="linkedInWaitingComponent" :removesso='true' />
  </div>
</template>

<script>
/* eslint-disable */
import linkedInWaitingComponent from '@/components/auth/sso/LinkedInWaitingComponent.vue';
import Modal from "@/components/shared/Modal";
export default {
	components: {
		Modal
	},
	data () {
		return {
			linkedInWaitingComponent: linkedInWaitingComponent
		}
	}
};
</script>

<style lang='scss' scoped>
.home {
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("/background.png") center center / cover;
}
</style>